import React from "react";

// Import Anddesign
import { Modal } from "antd";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  rootModal: {
    "& .ant-modal-title": {
      color: "#012970",
      fontFamily: "'Nunito', sans-serif",
    },
  },
}));

export default function AntdMasterModal(props) {
  const classes = useStyles();
  const { title, open, ...other } = props;
  return (
    <Modal
      className={classes.rootModal}
      title={title}
      closable={false}
      open={open}
      {...other}
    ></Modal>
  );
}
